import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";

interface Props {
	role: string;
	description: string;
}

const RoleCard = ({ role, description }: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<CardColumn className="roles-card-role" width="xl">
				{role}
			</CardColumn>
			<CardColumn className="" width="fill">
				<div className="roles-card-description--mobile-heading">
					{t("main.profile.description")}
				</div>
				{description}
			</CardColumn>
		</>
	);
};

export default RoleCard;
